
import two from '../assets/svg/projects/seva.png'




export const projectsData = [
    {
        id: 5,
        projectName: 'ChalChitra',
        projectDesc: 'This project is a movie and web series finder, means if user searches for any movie or web series name user get character details. It shows trending lists',
        tags: ['ReactJs','HTML', 'CSS', 'javaScript', 'NodeJS', 'material  Ui'],
        code: 'https://github.com/rht16/chalchitrabyrht',
        demo: 'https://chalchitra-by-rht16dev.netlify.app/',
        image: 'https://user-images.githubusercontent.com/87421802/153420760-68e3229d-a732-4a6a-9050-2fd0960fe2e4.png',
    },
   
    {
        id: 2,
        projectName: 'Seva The Food Sharing',
        projectDesc: 'This project is a food sharing and tracking system that allows users to donate the food to NGO or at hunger spot.',
        tags: ['ReactJs','HTML', 'CSS', 'javaScript'],
        code: 'https://github.com/mansisindhu/seva-the-food-sharing-frontend',
        demo: 'https://seva-the-food-sharing-frontend.vercel.app/',
        image: two
    },
    
    {
        id: 4,
        projectName: 'Nykaa Clone',
        projectDesc: 'This project is a clone of Nykaa.com. It built during our last construct week with UI designer collaboration.',
        tags: ['React', 'JavaScript', 'CSS', 'Package', 'Firebase'],
        code: 'https://github.com/rht16/nyka',
        demo: 'https://nykaaclonebypotatoes.netlify.app/',
        image: 'https://miro.medium.com/max/5744/1*90dHs7Uvk_KJrB-DiRtDcw.png'
    },
    {
        id: 1,
        projectName: 'Purplle Clone',
        projectDesc: 'Purpl le i s an onl ine s tore that sells cosmetics fragrances skin and hair care products for both men and women. HTML, CSS, JavaScript, NPM and MongoDB',
        tags: ['HTML', 'CSS', 'javaScript', 'mongoDB', 'NPM', 'hbs'],
        code: 'https://github.com/shaista78/Cloning_Website_Using_Backend',
        demo: 'https://purplleclone.herokuapp.com/html/home.html',
        image: 'https://user-images.githubusercontent.com/87421802/135706765-3bd3b680-fb72-497e-a4b2-8619bd026e3d.png'
    },
    {
        id: 3,
        projectName: 'Star wars Character',
        projectDesc: 'This project is a character finder, means if user searches for any of the star wars character user get character details.',
        tags: ['HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/rht16/star-war',
        demo: 'https://starwar16.herokuapp.com/wars.html',
        image: 'https://logos-download.com/wp-content/uploads/2016/09/Star_Wars_logo-1.png',
    },
]

